/**
 * Pre-render fallback data.
 *
 * The product, settings and blog values now come from
 * `prerenderData.generated.js`, which scripts/generate-prerender-data.mjs
 * writes from the LIVE API at build time (via the `prebuild` npm hook). That
 * keeps the pre-render snapshots that crawlers read in lock-step with the live
 * hydrated site, instead of a hand-maintained copy that inevitably goes stale.
 *
 * The generated file is gitignored. If it is missing the build fails loudly
 * (unresolved import) rather than shipping a stale snapshot. Only
 * `isPrerendering` - a runtime user-agent check - lives here.
 */

// True only while scripts/prerender.mjs is driving the page. The marker is
// appended to the user-agent by the pre-renderer and must match
// PRERENDER_UA_MARKER there. 'ReactSnap' stays in the pattern so a build
// directory produced by the old toolchain still reports correctly.
export const isPrerendering =
  typeof navigator !== 'undefined' &&
  /ASGPrerender|ReactSnap/.test(navigator.userAgent);

export {
  fallbackProducts,
  fallbackAccessories,
  fallbackBlogPosts,
  fallbackSettings,
} from './prerenderData.generated';

// startingAwningPrice is written by the generator too. Read it defensively via
// a namespace import so a stale generated file (missing the export) degrades to
// a safe default instead of failing the whole build.
import * as _generated from './prerenderData.generated';
export const startingAwningPrice = _generated.startingAwningPrice ?? 550;

// True only when public/docs/asg-sauleda-colour-chart.pdf exists at build time.
// Defaults to false so a stale generated file hides the download button rather
// than offering a link to a file that is not there.
export const colourChartAvailable = _generated.colourChartAvailable ?? false;
